import { render } from "./SacleBox.vue?vue&type=template&id=06cee970"
import script from "./SacleBox.vue?vue&type=script&lang=js"
export * from "./SacleBox.vue?vue&type=script&lang=js"

import "./SacleBox.vue?vue&type=style&index=0&id=06cee970&lang=scss"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__